import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations

const resources = {
  ar: { translation: require('./i18n/ar.json') },
  az: { translation: require('./i18n/az.json') },
  bg: { translation: require('./i18n/bg.json') },
  cs: { translation: require('./i18n/cs.json') },
  da: { translation: require('./i18n/da.json') },
  de: { translation: require('./i18n/de.json') },
  el: { translation: require('./i18n/el.json') },
  en: { translation: require('./i18n/en.json') },
  es: { translation: require('./i18n/es.json') },
  et: { translation: require('./i18n/et.json') },
  fa: { translation: require('./i18n/fa.json') },
  fi: { translation: require('./i18n/fi.json') },
  fr: { translation: require('./i18n/fr.json') },
  ga: { translation: require('./i18n/ga.json') },
  hr: { translation: require('./i18n/hr.json') },
  hu: { translation: require('./i18n/hu.json') },
  hy: { translation: require('./i18n/hy.json') },
  it: { translation: require('./i18n/it.json') },
  ka: { translation: require('./i18n/ka.json') },
  kk: { translation: require('./i18n/kk.json') },
  ky: { translation: require('./i18n/ky.json') },
  lt: { translation: require('./i18n/lt.json') },
  lv: { translation: require('./i18n/lv.json') },
  mt: { translation: require('./i18n/mt.json') },
  nl: { translation: require('./i18n/nl.json') },
  pl: { translation: require('./i18n/pl.json') },
  pt: { translation: require('./i18n/pt.json') },
  ro: { translation: require('./i18n/ro.json') },
  ru: { translation: require('./i18n/ru.json') },
  sk: { translation: require('./i18n/sk.json') },
  sv: { translation: require('./i18n/sv.json') },
  tg: { translation: require('./i18n/tg.json') },
  tk: { translation: require('./i18n/tk.json') },
  tr: { translation: require('./i18n/tr.json') },
  uk: { translation: require('./i18n/uk.json') },
  ur: { translation: require('./i18n/ur.json') },
  uz: { translation: require('./i18n/uz.json') },
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en",
    fallbackLng: "en",
    keySeparator: ":", // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    },
    ns: ['translation'],
    defaultNS: 'translation',
    partialBundledLanguages: "true"
  });

export default i18n;
